import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`
export const CampaignsIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.3008 15.1L18.5008 12.3C18.4008 12.2 18.3008 12.2 18.2008 12.2H15.2008C15.0008 12.2 14.8008 12.4 14.8008 12.6V15.6C14.8008 15.7 14.8008 15.8 14.9008 15.9L17.7008 18.7C18.0008 19 18.5008 19 18.8008 18.7L21.3008 16.2C21.6008 15.9 21.6008 15.4 21.3008 15.1ZM16.4008 14.5C16.0008 14.5 15.7008 14.2 15.7008 13.8C15.7008 13.4 16.0008 13.1 16.4008 13.1C16.8008 13.1 17.1008 13.4 17.1008 13.8C17.1008 14.2 16.8008 14.5 16.4008 14.5Z" />
      <path d="M10.4004 12.1C12.3334 12.1 13.9004 10.533 13.9004 8.60001C13.9004 6.66701 12.3334 5.10001 10.4004 5.10001C8.46739 5.10001 6.90039 6.66701 6.90039 8.60001C6.90039 10.533 8.46739 12.1 10.4004 12.1Z" />
      <path d="M16.1 18.2L14 16.2C13.9 16.1 13.8 15.9 13.8 15.7V13.4C13.8 13.2 13.6 13 13.4 13H11.9C11.4 13.2 10.9 13.4 10.4 13.4C9.9 13.4 9.4 13.3 8.9 13H7.5C5.8 13 4.5 14.4 4.5 16.1V17.8C4.5 18.4 5 18.8 5.5 18.8H15.8C16.1 18.9 16.3 18.5 16.1 18.2Z" />
    </Svg>
  )
}
